import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import styles from "./AdminPanel.module.css";

import Main from "./content/Main";
import Company from "./content/Company";
import Clients from "./content/Clients";
import Chats from "./content/Chats";
import Tickets from "./content/Tickets";
import Banners from "./content/Banners";
import Settings from "./content/Settings";
import Help from "./content/Help";

function AdminPanel({ user, onLogout }) {
  return (
    <Router>
      <div className={styles.layout}>
        <Sidebar onLogout={onLogout} />

        <main className={styles.content}>
          <Routes>
            <Route path="/content/main" element={<Main user={user} />} />
            <Route path="/content/company" element={<Company user={user} />} />
            <Route path="/content/clients" element={<Clients user={user} />} />
            <Route path="/content/chats" element={<Chats user={user} />} />
            <Route path="/content/tickets" element={<Tickets user={user} />} />
            <Route path="/content/banners" element={<Banners user={user} />} />
            <Route path="/content/settings" element={<Settings user={user} />} />
            <Route path="/content/help" element={<Help user={user} />} />
            
            {/* По умолчанию редирект на Главную */}
            <Route path="*" element={<Navigate to="/content/main" replace />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default AdminPanel;
